import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitonashikcab() {



    const cardData = {




keyword: "Mumbai to Nashik Cab",

headingDescription: "Shreesha Tours & Travels provides reliable, affordable, and comfortable Mumbai to Nashik cab services for business travelers, families, tourists, corporate clients, pilgrims, and weekend travelers. We offer one-way cabs, round-trip taxi services, airport transfers, multi-city travel, and customized outstation tour packages with professional chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury vehicles suitable for individuals, families, and large groups. With doorstep pickup anywhere in Mumbai, flexible departure timings, transparent pricing, easy online booking, and 24/7 customer support, we ensure a safe, smooth, and enjoyable journey. Whether you are planning a pilgrimage to Trimbakeshwar, a wine tour, a corporate visit, a family vacation, or a weekend getaway, Shreesha Tours & Travels offers dependable Mumbai to Nashik cab services with clean vehicles, experienced drivers, and excellent customer service. Enjoy a relaxing road trip through the scenic Western Ghats while traveling comfortably to one of Maharashtra's most popular spiritual, cultural, and tourism destinations.",

topPlaces: [
  {
    title: "Trimbakeshwar Temple",
    description: "Trimbakeshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and one of the most important pilgrimage destinations in India. Located near Nashik, the temple is renowned for its ancient architecture, religious rituals, and spiritual significance. Thousands of devotees visit throughout the year, especially during festivals like Mahashivratri and the Kumbh Mela."
  },
  {
    title: "Sula Vineyards",
    description: "Sula Vineyards is India's most famous wine destination, attracting visitors from across the country. Known for premium wine tasting, vineyard tours, luxury resorts, fine dining, and the annual SulaFest, it is a must-visit destination for couples, families, and wine enthusiasts exploring Nashik."
  },
  {
    title: "Panchavati",
    description: "Panchavati is one of Nashik's most sacred religious areas, closely associated with the Ramayana. The area is home to several temples, ghats, and holy sites including Kalaram Temple, Sita Gufa, and Ram Kund, making it an essential stop for pilgrims visiting Nashik."
  },
  {
    title: "Ram Kund",
    description: "Ram Kund is a sacred bathing ghat on the banks of the Godavari River where Lord Rama is believed to have performed rituals during his exile. It is an important pilgrimage site and attracts thousands of devotees who come to perform religious ceremonies and holy rituals."
  },
  {
    title: "Pandavleni Caves",
    description: "The Pandavleni Caves are ancient Buddhist rock-cut caves dating back over 2,000 years. These historical monuments feature beautiful carvings, inscriptions, meditation halls, and panoramic views of Nashik city, making them a favorite destination for history lovers and tourists."
  },
  {
    title: "Anjaneri Hills",
    description: "Anjaneri Hills are believed to be the birthplace of Lord Hanuman and are popular among pilgrims and trekking enthusiasts. The scenic trekking route, temples, lush greenery, and panoramic mountain views make it one of the most visited attractions near Nashik."
  },
  {
    title: "Harihar Fort",
    description: "Harihar Fort is one of Maharashtra's most adventurous trekking destinations, famous for its nearly vertical rock-cut staircase and breathtaking hilltop views. Adventure lovers and photographers frequently visit this unique fort for an unforgettable trekking experience."
  },
  {
    title: "Igatpuri",
    description: "Located on the Mumbai–Nashik route, Igatpuri is a beautiful hill station known for mist-covered mountains, waterfalls, trekking trails, and the Vipassana International Academy. It is a popular stop for travelers seeking nature, peace, and scenic landscapes."
  },
  {
    title: "Bhandardara",
    description: "Bhandardara is a peaceful hill destination known for Arthur Lake, Randha Falls, Wilson Dam, Umbrella Falls, and lush green valleys. It is an ideal getaway for families, couples, photographers, and nature lovers visiting the Nashik region."
  },
  {
    title: "Shirdi",
    description: "Shirdi is one of India's most famous pilgrimage destinations and is located close to Nashik. Home to the revered Shri Sai Baba Samadhi Mandir, it attracts millions of devotees every year. Many travelers combine Nashik and Shirdi in a single spiritual and sightseeing tour."
  }
],




"services": [
  {
    "name": "Mumbai Nashik Cab",
    "description": "Book Mumbai Nashik Cab for safe, comfortable, and reliable outstation travel with professional chauffeurs and well-maintained AC vehicles. Choose Sedan, Ertiga, Innova Crysta, and SUV cabs for family trips, business travel, and one way or round trip journeys."
  },
  {
    "name": "Mumbai to Nashik Taxi Fare",
    "description": "Check Mumbai to Nashik Taxi Fare with transparent pricing, affordable packages, and no hidden charges for one way and round trip travel."
  },
  {
    "name": "Mumbai Airport to Nashik Taxi",
    "description": "Hire Mumbai Airport to Nashik Taxi with direct airport pickup, experienced chauffeurs, and comfortable AC vehicles for hassle-free airport transfers."
  },
  {
    "name": "Mumbai Airport to Nashik Taxi Fare",
    "description": "Get Mumbai Airport to Nashik Taxi Fare with competitive pricing, premium vehicles, and reliable airport transfer services."
  },
  {
    "name": "Mumbai to Deolali Cab",
    "description": "Book Mumbai to Deolali Cab with professional drivers, comfortable vehicles, and affordable travel packages for family and business trips."
  },
  {
    "name": "Mumbai to Deolali Taxi Fare",
    "description": "Check Mumbai to Deolali Taxi Fare with transparent pricing and budget-friendly travel options for every journey."
  },
  {
    "name": "Mumbai Airport to Nashik Cab",
    "description": "Reserve Mumbai Airport to Nashik Cab with instant airport pickup, spacious AC vehicles, and professional chauffeurs."
  },
  {
    "name": "Mumbai to Nashik Taxi Service",
    "description": "Choose Mumbai to Nashik Taxi Service for reliable transportation with experienced drivers, clean vehicles, and flexible booking options."
  },
  {
    "name": "Mumbai Airport to Nashik Taxi",
    "description": "Book Mumbai Airport to Nashik Taxi for direct airport transfers with safe, comfortable, and punctual chauffeur-driven services."
  },
  {
    "name": "Mumbai Airport to Nashik Taxi Fare",
    "description": "Find Mumbai Airport to Nashik Taxi Fare with affordable rates and premium taxi services for convenient travel."
  },
  {
    "name": "Mumbai Airport to Nashik Taxi Service",
    "description": "Hire Mumbai Airport to Nashik Taxi Service with professional chauffeurs, clean vehicles, and reliable airport pickup facilities."
  },
  {
    "name": "Mumbai Airport to Nashik Cab Fare",
    "description": "Check Mumbai Airport to Nashik Cab Fare with competitive pricing and comfortable outstation cab options."
  },
  {
    "name": "Mumbai Airport to Nashik Cab Service",
    "description": "Book Mumbai Airport to Nashik Cab Service with premium chauffeur-driven vehicles and reliable airport transportation."
  },
  {
    "name": "Mumbai to Nashik Cab Booking",
    "description": "Complete Mumbai to Nashik Cab Booking online with instant confirmation, multiple vehicle choices, and flexible travel schedules."
  },
  {
    "name": "Mumbai to Nashik One Way Cab",
    "description": "Reserve Mumbai to Nashik One Way Cab for affordable point-to-point travel with fixed pricing and no return charges."
  },
  {
    "name": "Mumbai to Nashik Taxi Booking",
    "description": "Book Mumbai to Nashik Taxi Booking with quick reservations, experienced drivers, and comfortable AC vehicles."
  },
  {
    "name": "Navi Mumbai to Nashik Cab",
    "description": "Choose Navi Mumbai to Nashik Cab for safe and comfortable outstation travel with professional chauffeurs and affordable fares."
  },
  {
    "name": "Navi Mumbai Airport to Nashik Cab",
    "description": "Hire Navi Mumbai Airport to Nashik Cab with direct airport pickup and premium chauffeur-driven transportation."
  },
  {
    "name": "Thane to Nashik Cab",
    "description": "Book Thane to Nashik Cab for convenient intercity travel with comfortable vehicles and experienced drivers."
  },
  {
    "name": "Thane Nashik Taxi Service",
    "description": "Choose Thane Nashik Taxi Service for reliable transportation with clean AC vehicles and professional chauffeurs."
  },
  {
    "name": "Thane to Nashik Cab Service",
    "description": "Reserve Thane to Nashik Cab Service with affordable fares, premium vehicles, and flexible one way or round trip options."
  },
  {
    "name": "Thane to Nashik Cab Fare",
    "description": "Check Thane to Nashik Cab Fare with transparent pricing and quality chauffeur-driven services."
  },
  {
    "name": "Thane to Nashik Taxi Fare",
    "description": "Get Thane to Nashik Taxi Fare with competitive pricing and comfortable AC taxi services."
  },
  {
    "name": "Mumbai to Nashik Cab Service Near Me",
    "description": "Find Mumbai to Nashik Cab Service Near Me with quick booking, professional drivers, and convenient doorstep pickup."
  },
  {
    "name": "Best Cab Service Mumbai to Nashik",
    "description": "Choose the Best Cab Service Mumbai to Nashik with premium vehicles, experienced chauffeurs, and dependable customer support."
  },
  {
    "name": "Reliable Mumbai Nashik Taxi",
    "description": "Book Reliable Mumbai Nashik Taxi with safe transportation, transparent pricing, and well-maintained chauffeur-driven vehicles."
  },
  {
    "name": "24x7 Mumbai Nashik Cab Service",
    "description": "Hire 24x7 Mumbai Nashik Cab Service with round-the-clock availability, instant booking, and reliable outstation transportation."
  },
  {
    "name": "Instant Mumbai Nashik Cab Booking",
    "description": "Complete Instant Mumbai Nashik Cab Booking with quick confirmation, affordable fares, and multiple vehicle options."
  },
  {
    "name": "Mumbai Nashik Taxi Contact Number",
    "description": "Get Mumbai Nashik Taxi Contact Number for instant cab booking, travel assistance, and reliable customer support."
  },
  {
    "name": "Mumbai Nashik Cab Rental Service",
    "description": "Choose Mumbai Nashik Cab Rental Service for chauffeur-driven vehicles, comfortable travel, and flexible rental packages."
  },
  {
    "name": "Mumbai Nashik Airport Transfer",
    "description": "Book Mumbai Nashik Airport Transfer with timely airport pickup and drop services using comfortable AC vehicles."
  },
  {
    "name": "One Way Taxi Mumbai to Nashik",
    "description": "Reserve One Way Taxi Mumbai to Nashik for affordable one-way travel with fixed fares and experienced chauffeurs."
  },
  {
    "name": "Mumbai Nashik Travel Service",
    "description": "Hire Mumbai Nashik Travel Service for safe long-distance journeys with premium vehicles and professional drivers."
  },
  {
    "name": "Mumbai to Nashik Cab Service",
    "description": "Book Mumbai to Nashik Cab Service with Sedan, Ertiga, Innova Crysta, and SUV vehicles for comfortable family and corporate travel."
  },
  {
    "name": "Mumbai to Nashik Taxi Booking",
    "description": "Reserve Mumbai to Nashik Taxi Booking online with instant confirmation and reliable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai to Nashik One Way Taxi",
    "description": "Choose Mumbai to Nashik One Way Taxi for economical travel with clean AC vehicles and professional drivers."
  },
  {
    "name": "Mumbai Airport to Nashik Cab",
    "description": "Book Mumbai Airport to Nashik Cab with direct airport pickup and comfortable chauffeur-driven transportation."
  },
  {
    "name": "Mumbai to Trimbakeshwar Cab Service",
    "description": "Hire Mumbai to Trimbakeshwar Cab Service for convenient pilgrimage travel with experienced chauffeurs and spacious AC vehicles."
  },
  {
    "name": "Mumbai to Nashik Outstation Cab",
    "description": "Book Mumbai to Nashik Outstation Cab for reliable intercity travel with flexible one way and round trip options."
  },
  {
    "name": "Mumbai to Nashik Innova Crysta Cab",
    "description": "Reserve Mumbai to Nashik Innova Crysta Cab for luxury travel with spacious seating and premium comfort."
  },
  {
    "name": "Mumbai to Nashik Ertiga Taxi",
    "description": "Choose Mumbai to Nashik Ertiga Taxi for affordable 6 to 7 seater family travel with experienced chauffeurs."
  },
  {
    "name": "Mumbai to Nashik Round Trip Cab",
    "description": "Book Mumbai to Nashik Round Trip Cab with economical return packages, comfortable vehicles, and flexible travel schedules."
  },
  {
    "name": "Mumbai Nashik Taxi Fare & Booking",
    "description": "Get Mumbai Nashik Taxi Fare & Booking with transparent pricing, instant confirmation, and premium chauffeur-driven cab services."
  }
],
"tableData": [
  ["Mumbai Nashik Cab", "Mumbai to Nashik Taxi Fare"],
  ["Mumbai Airport to Nashik Taxi", "Mumbai Airport to Nashik Taxi Fare"],
  ["Mumbai to Deolali Cab", "Mumbai to Deolali Taxi Fare"],
  ["Mumbai Airport to Nashik Cab", "Mumbai to Nashik Taxi Service"],
  ["Mumbai Airport to Nashik Taxi Service", "Mumbai Airport to Nashik Cab Fare"],
  ["Mumbai Airport to Nashik Cab Service", "Mumbai to Nashik Cab Booking"],
  ["Mumbai to Nashik One Way Cab", "Mumbai to Nashik Taxi Booking"],
  ["Navi Mumbai to Nashik Cab", "Navi Mumbai Airport to Nashik Cab"],
  ["Thane to Nashik Cab", "Thane Nashik Taxi Service"],
  ["Thane to Nashik Cab Service", "Thane to Nashik Cab Fare"],
  ["Thane to Nashik Taxi Fare", "Mumbai to Nashik Cab Service Near Me"],
  ["Best Cab Service Mumbai to Nashik", "Reliable Mumbai Nashik Taxi"],
  ["24x7 Mumbai Nashik Cab Service", "Instant Mumbai Nashik Cab Booking"],
  ["Mumbai Nashik Taxi Contact Number", "Mumbai Nashik Cab Rental Service"],
  ["Mumbai Nashik Airport Transfer", "One Way Taxi Mumbai to Nashik"],
  ["Mumbai Nashik Travel Service", "Mumbai to Nashik Cab Service"],
  ["Mumbai to Nashik Taxi Booking", "Mumbai to Nashik One Way Taxi"],
  ["Mumbai Airport to Nashik Cab", "Mumbai to Trimbakeshwar Cab Service"],
  ["Mumbai to Nashik Outstation Cab", "Mumbai to Nashik Innova Crysta Cab"],
  ["Mumbai to Nashik Ertiga Taxi", "Mumbai to Nashik Round Trip Cab"],
  ["Mumbai Nashik Taxi Fare & Booking", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Mumbai to Nashik Cab Service",
    WhyChoosedescription: "Shreesha Tours & Travels offers dependable Mumbai to Nashik cab services with clean vehicles, experienced chauffeurs, and comfortable travel for business trips, family outings, pilgrimages, and weekend holidays."
  },
  {
    WhyChooseheading: "Convenient City-to-City Travel",
    WhyChoosedescription: "Enjoy a hassle-free journey with doorstep pickup from anywhere in Mumbai and direct drop-off at your preferred destination in Nashik without changing vehicles."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Every Journey",
    WhyChoosedescription: "Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium cars based on your travel requirements and group size."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Booking",
    WhyChoosedescription: "Book a one-way cab for direct travel or select a round-trip package with flexible return timings to match your itinerary."
  },
  {
    WhyChooseheading: "Professional Drivers for Safe Highway Travel",
    WhyChoosedescription: "Our experienced drivers ensure a smooth, safe, and punctual journey on the Mumbai to Nashik route while prioritizing passenger comfort."
  },
  {
    WhyChooseheading: "Ideal for Pilgrimage, Business & Leisure",
    WhyChoosedescription: "Whether you're visiting Trimbakeshwar Temple, Sula Vineyards, business locations, or planning a family holiday, our cab service is designed for every travel purpose."
  },
  {
    WhyChooseheading: "Clean & Well-Maintained Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced and equipped with comfortable seating, clean interiors, and ample luggage space for a pleasant long-distance journey."
  },
  {
    WhyChooseheading: "Quick Booking with Shreesha Tours & Travels",
    WhyChoosedescription: "Book your Mumbai to Nashik taxi easily with transparent pricing, responsive customer support, and instant booking assistance."
  }
]

};

const faqData = [
  {
    question: "Does Shreesha Tours & Travels provide Mumbai to Nashik Cab Service?",
    answer: "Yes, we provide Mumbai to Nashik cab services for one-way, round-trip, business, family, and pilgrimage travel."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Nashik?",
    answer: "Yes, one-way taxi services are available for passengers travelling directly from Mumbai to Nashik."
  },
  {
    question: "Which vehicles are available for Mumbai to Nashik travel?",
    answer: "You can book Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Is the cab suitable for family travel?",
    answer: "Yes, our spacious and comfortable vehicles are perfect for families, groups, senior citizens, and corporate travellers."
  },
  {
    question: "Can I book a round-trip taxi from Mumbai to Nashik?",
    answer: "Yes, we offer flexible round-trip cab packages based on your preferred return schedule."
  },
  {
    question: "Can I include Trimbakeshwar or nearby sightseeing in my trip?",
    answer: "Yes, your itinerary can be customized to include Trimbakeshwar Temple, Sula Vineyards, Panchavati, and other nearby attractions."
  },
  {
    question: "Do you provide pickup from Mumbai Airport, hotels, and railway stations?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, homes, offices, and any preferred location in Mumbai."
  },
  {
    question: "Are tolls and parking charges included in the fare?",
    answer: "Toll charges, parking fees, permits, and other applicable charges depend on the selected package and are explained before booking."
  },
  {
    question: "Is Mumbai to Nashik cab service available every day?",
    answer: "Yes, Shreesha Tours & Travels provides daily cab services subject to advance booking and vehicle availability."
  },
  {
    question: "How can I book a Mumbai to Nashik Cab?",
    answer: "Simply share your pickup location, travel date, passenger details, destination, and preferred vehicle to receive a fare quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kunal Shah",
    feedback: "Shreesha Tours & Travels provided an excellent Mumbai to Nashik cab service. The driver was punctual, the car was clean, and the entire journey was comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priyanka Deshpande",
    feedback: "We booked an Innova Crysta for our Nashik family trip, and the service exceeded our expectations. Smooth ride, professional driver, and hassle-free booking.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Nashik Cab",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-nashik-cab.webp",
  "description":
    "Book Mumbai Nashik Cab with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Nashik, Deolali, and nearby destinations with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for business travel, pilgrimage tours, airport transfers, and family trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-nashik-cab"
  }
};





    return (
        <div>


<Helmet>
  <title>Mumbai Nashik Cab | Fast & Reliable Taxi | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai Nashik Cab with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Nashik, Deolali, and Mumbai Airport with 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai Nashik Cab, Mumbai to Nashik Taxi Fare, Mumbai Airport to Nashik Taxi, Mumbai Airport to Nashik Taxi Fare, Mumbai to Deolali Cab, Mumbai to Deolali Taxi, Mumbai to Nashik Cab, Mumbai to Nashik Taxi, Mumbai Nashik Cab Service, Mumbai Nashik Taxi Service, Mumbai to Nashik One Way Cab, Mumbai to Nashik Round Trip Cab, Nashik Car Rental from Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitonashikcab;